import {Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(private spinner: NgxSpinnerService) {

  }

  ngOnInit() {

  }


  showSpinner() {
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 5000);
  }

  // servidor: Servidor;
  // private handleError: HandleError;
  // title = 'Transparecia';
  // servico: ConfigService;
  // name: string;
  // isVisible: boolean;
  // isEnable: boolean;
  //
  // referencia: Ref[] = [];
  // categoria: CategoriaModel[] = [];
  // detalhes = [];
  // servidores: Servidor[] = [];
  //
  // urlBase: String = 'http://localhost:8080/api';
  // configUrlPessoa = '/listapessoas/100/0/20';
  // configUrlReferncia = '/buscaReferencia';
  // urlNode = 'http://localhost:3000/publica/api/11111111/pesq';
  // urlNodeRef = 'http://localhost:3000/publica/api/11111111/buscaReferencia';
  // urlNodeCat = 'http://localhost:3000/publica/api/11111111/listaCategoria';
  // urlNodeDetalhe = 'http://localhost:3000/publica/api/11111111/detalhaMovimento';
  //
  // ngOnInit() {
  //
  //   console.log('Parametros')
  //
  //   if (this.route.snapshot.queryParams)
  //     console.log(this.route.snapshot.params); // e.g. :param1 in routeConfig
  //   if (this.route.snapshot.queryParamMap.get('param1'))
  //     console.log(this.route.snapshot.queryParamMap.get('param1')); //
  //
  //   this.route.paramMap.subscribe(params => {
  //     console.log(params[0])
  //   })
  //   // console.log('Estou aqui', this.ar.url);
  //
  //   this.getReferencia().subscribe(data => {
  //     this.referencia = data;
  //   });
  //
  //   // this.getCategoria().subscribe(data => {
  //   //   this.categoria = data;
  //   // });
  //
  //   // this.getCategoria().then(response => {
  //   //   response.json().then( data => this.categoria = data).catch(err => console.log('Não encontrado'))
  //   // }).catch();
  //
  //   this.infCategoria();
  //   this.spinner.hide();
  // }
  //
  // constructor(private route: ActivatedRoute, private http: HttpClient, private spinner: NgxSpinnerService) {
  //   this.isVisible = false;
  //   this.isEnable = true;
  //   this.name = '';
  // }
  //
  //
  // async infCategoria() {
  //   const response = await this.getCategoria();
  //   const data = await response.json();
  //   this.categoria = data;
  // }
  //
  // /** GET heroes from the server */
  // getServidor(digitado: string, valorReferencia: string, valorCategoria: string): Observable<Servidor[]> {
  //   this.spinner.show();
  //   return this.http.get<Servidor[]>(`${this.urlNode}/${digitado}/${valorReferencia}/${valorCategoria}`);
  //   // return this.http.get<Servidor[]>(`${this.urlBase}${this.configUrlPessoa}/${digitado}`);
  // }
  //
  // /** GET heroes from the server */
  // getReferencia(): Observable< Ref[] > {
  //   this.spinner.show();
  //   // return this.http.get<Referencia[]>(this.urlBase + this.configUrlReferncia);
  //   return this.http.get<Ref[]>(this.urlNodeRef);
  // }
  //
  // buscaServidor(digitado: string,  valorReferencia: string, valorCategoria: string) {
  //   this.getServidor(digitado, valorReferencia, valorCategoria).subscribe(pessoas => {
  //       this.servidores = pessoas;
  //       this.isVisible = true;
  //       this.spinner.hide();
  //   });
  //   // if (this.servidores) {
  //   //   this.isVisible = true;
  //   // } else {
  //   //   this.isVisible = false;
  //   // }
  // }
  //
  // preenchido(parametro: string): boolean {
  //   this.name = parametro;
  //   this.isEnable = parametro.length < 5;
  //   this.isVisible = false;
  //   // this.isVisible = parametro.length >= 5;
  //   this.servidores = [];
  //   return this.isEnable;
  // }
  //
  // // private getCategoria(): Observable< CategoriaModel[] > {
  // //     return this.http.get<CategoriaModel[]>(this.urlNodeCat);
  // // }
  //
  // private getCategoria() {
  //   return fetch( this.urlNodeCat );
  // }
  //
  //
  // private getMovimento(codFnc: number, datref: string, codEmp: number) {
  //   this.spinner.show();
  //   return fetch( `${this.urlNodeDetalhe}/${codFnc}/${datref}/${codEmp}` );
  // }
  //
  //
  // async detalhaServidor(codFnc: number, datref: string, codEmp: number) {
  //   const response = await this.getMovimento(codFnc, datref, codEmp);
  //   const data = await response.json();
  //   this.detalhes = data;
  //   this.spinner.hide();
  // }
  //
  // escondeDetalhes(number: number) {
  //   this.detalhes = [];
  // }
  //
  // hasNoSelectedServidores() {
  //   return this.servidores.length === 0;
  // }
  //
  // hasNoSelectedDetalhes(mat: number) {
  //   for (let det in this.detalhes) {
  //     return this.detalhes[det].MATRICULA == mat;
  //   }
  //   return false;
  // }
}
